(async function () {
  const root = document.currentScript.closest('.petso-series-products');
  const featureBar = root.querySelector('.petso-series-feature-tabs');
  const featureList = featureBar?.querySelector('.petso-series-feature-tabs__list');
  const featurePlaceholder = root.querySelector('.petso-series-feature-placeholder');
  const filterBar = root.querySelector('.petso-series-filterbar');
  function installStickyTabs() {
    if (!featureBar || !featurePlaceholder || featureBar.dataset.stickyReady === 'true') return;
    featureBar.dataset.stickyReady = 'true';
    let ticking = false;
    function headerOffset() {
      const header = document.querySelector('sticky-header, .header-wrapper, header');
      return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    }
    function update() {
      ticking = false;
      const topOffset = headerOffset();
      const anchor = featureBar.classList.contains('is-fixed') ? featurePlaceholder : featureBar;
      const shouldFix = anchor.getBoundingClientRect().top <= topOffset;
      const pinMobileFilters = shouldFix && window.matchMedia('(max-width: 749px)').matches && Boolean(filterBar);
      featureBar.style.setProperty('--petso-feature-tab-top', topOffset + 'px');
      featureBar.classList.toggle('is-fixed', shouldFix);
      filterBar?.classList.toggle('is-mobile-fixed', pinMobileFilters);
      if (filterBar) filterBar.style.setProperty('--petso-series-filter-top', (topOffset + featureBar.offsetHeight) + 'px');
      featurePlaceholder.classList.toggle('is-active', shouldFix);
      featurePlaceholder.style.height = shouldFix ? (featureBar.offsetHeight + (pinMobileFilters ? filterBar.offsetHeight : 0)) + 'px' : '0px';
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, {passive:true});
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  if (!root.dataset.catalogUrl) { installStickyTabs(); return; }
  const response = await fetch(root.dataset.catalogUrl, {cache: 'no-store'});
  if (!response.ok) throw new Error('Product catalogue could not be loaded');
  const catalog = await response.json();
  const grid = root.querySelector('.petso-series-product-grid');
  const count = root.querySelector('.petso-series-count');
  const availability = root.querySelector('[data-filter="availability"]');
  const brand = root.querySelector('[data-filter="brand"]');
  const type = root.querySelector('[data-filter="type"]');
  const price = root.querySelector('[data-filter="price"]');
  const sort = root.querySelector('[data-filter="sort"]');
  let selectedFeature = 'all';
  const money = new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'});
  const escape = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const choices = (items) => [...new Set(items.filter(Boolean))].sort((a,b) => a.localeCompare(b));
  function fill(container, values, allLabel) {
    container.innerHTML = '';
    const all = document.createElement('label');
    all.innerHTML = '<input type="radio" name="' + container.dataset.filter + '" value="all" checked> ' + allLabel;
    container.append(all);
    values.forEach(value => {
      const option = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'radio'; input.name = container.dataset.filter; input.value = value;
      option.append(input, document.createTextNode(' ' + value)); container.append(option);
    });
  }
  function chosen(box) { return box.querySelector('input:checked')?.value || 'all'; }
  function matchesPrice(product, selected) {
    const value = Number(product.minPrice || 0);
    return selected === 'all' || (selected === 'under_50' && value < 50) || (selected === '50_150' && value >= 50 && value < 150) || (selected === '150_500' && value >= 150 && value < 500) || (selected === 'over_500' && value >= 500);
  }
  function priorityCompare(a, b) {
    const availability = Number(Boolean(b.availableForSale)) - Number(Boolean(a.availableForSale));
    if (availability) return availability;
    const role = Number(Boolean(a.accessory)) - Number(Boolean(b.accessory));
    if (role) return role;
    const recency = new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime();
    if (recency) return recency;
    return a.title.localeCompare(b.title);
  }
  function card(product) {
    const article = document.createElement('article');
    article.className = 'petso-series-card' + (product.availableForSale ? '' : ' petso-series-card--soldout');
    const label = product.cardLabel || (product.accessory ? 'Compatible accessory' : 'Smart product');
    article.innerHTML = `<a class="petso-series-card__media" href="https://www.petso.com.au/products/${escape(product.handle)}"><img src="${escape(product.featuredImage)}" alt="${escape(product.title)}" loading="lazy"></a><div class="petso-series-card__body"><div class="petso-series-card__type">${escape(label)}</div><h3>${escape(product.title)}</h3><div class="petso-series-card__price">${money.format(Number(product.minPrice || 0))}</div><div class="petso-series-card__status">${product.availableForSale ? '' : 'Sold out'}</div><a class="petso-series-card__cta" href="https://www.petso.com.au/products/${escape(product.handle)}">${product.availableForSale ? 'View product' : 'View details'}</a></div>`;
    return article;
  }
  function render() {
    const current = {availability: chosen(availability), brand: chosen(brand), type: chosen(type), price: chosen(price), sort: sort.value};
    let products = catalog.filter(product =>
      (selectedFeature === 'all' || (product.featureIds || []).includes(selectedFeature)) &&
      (current.availability === 'all' || (current.availability === 'in_stock' ? product.availableForSale : !product.availableForSale)) &&
      (current.brand === 'all' || product.vendor === current.brand) &&
      (current.type === 'all' || product.productType === current.type) && matchesPrice(product, current.price)
    );
    if (current.sort === 'priority') products = [...products].sort(priorityCompare);
    if (current.sort === 'price_low') products = [...products].sort((a,b) => Number(a.minPrice)-Number(b.minPrice) || a.title.localeCompare(b.title));
    if (current.sort === 'price_high') products = [...products].sort((a,b) => Number(b.minPrice)-Number(a.minPrice) || a.title.localeCompare(b.title));
    if (current.sort === 'alpha') products = [...products].sort((a,b) => a.title.localeCompare(b.title));
    grid.innerHTML = '';
    if (!products.length) grid.innerHTML = '<p class="petso-series-empty">' + escape(root.dataset.emptyMessage || 'No products match these filters.') + '</p>';
    products.forEach(product => grid.append(card(product)));
    count.textContent = `${products.length} product${products.length === 1 ? '' : 's'}`;
  }
  async function initialiseFeatureTabs() {
    if (!featureBar?.dataset.featureUrl || !featureList) { installStickyTabs(); return; }
    const featureResponse = await fetch(featureBar.dataset.featureUrl, {cache:'no-store'});
    if (!featureResponse.ok) throw new Error('Feature filters could not be loaded');
    const features = await featureResponse.json();
    const buildButton = (id, label, active) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'petso-series-feature-tab' + (active ? ' is-active' : '');
      button.dataset.feature = id; button.textContent = label; button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.addEventListener('click', () => {
        selectedFeature = id;
        featureList.querySelectorAll('[data-feature]').forEach(tab => {
          const isActive = tab.dataset.feature === id;
          tab.classList.toggle('is-active', isActive); tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        render();
      });
      return button;
    };
    featureList.innerHTML = '';
    featureList.append(buildButton('all', 'All', true));
    (features.tabs || []).forEach(feature => featureList.append(buildButton(feature.id, feature.label, false)));
    installStickyTabs();
  }
  fill(availability, ['in_stock', 'sold_out'], 'All availability');
  fill(brand, choices(catalog.map(p => p.vendor)), 'All brands');
  fill(type, choices(catalog.map(p => p.productType)), 'All product types');
  fill(price, ['under_50', '50_150', '150_500', 'over_500'], 'All prices');
  root.querySelectorAll('input, select').forEach(control => control.addEventListener('change', render));
  await initialiseFeatureTabs();
  render();
  const recommendation = root.closest('.petso-series-shell').querySelector('.petso-series-recommendations[data-catalog-url]');
  if (recommendation) {
    const recommendationResponse = await fetch(recommendation.dataset.catalogUrl, {cache: 'no-store'});
    if (!recommendationResponse.ok) throw new Error('Recommendation catalogue could not be loaded');
    const products = (await recommendationResponse.json()).sort(priorityCompare);
    const recommendationGrid = recommendation.querySelector('.petso-series-recommendation-grid');
    recommendationGrid.innerHTML = '';
    products.forEach(product => recommendationGrid.append(card(product)));
  }
}());
